<ng-template #content let-modal>
    <div class="modal-header red">
        <div class="container-fluid">
            <div class="row modal-header-row">
                <img class="modal-icon" src="assets/ico/exclamation-triangle-regular-white.svg" alt="icon">
                <span class="modal-title" id="modal-basic-title">Error</span>

            </div>
        </div>
    </div>
    <div class="modal-body">
        <div *ngFor="let error of errors, let last = last;">
            <p [class.pb-5]="errors.length > 1 && !last">
                <span *ngIf="error.message" class="error-details"><strong>{{error.message}}</strong></span>
                <span *ngIf="error.details" class="error-secondary-details">{{error.details}}</span>
                <span *ngIf="!error.message && !error.details"
                    class="error-details"><strong>{{'modals.error.unknownError' | translate}}</strong></span>           
                <ng-template ngFor let-item [ngForOf]="error.validationErrors" let-i="index">
                    <div class="error-secondary-details mt-3">
                        <span *ngIf="item.fieldName"> <strong>{{'columnName.' + item.fieldName |
                                translate}}:</strong></span>
                        {{item.message}}
                    </div>
                </ng-template>
                <span *ngIf="error.errorTraceId" class="error-secondary-details"
                    style="margin-top: 2em;"><strong>{{'modals.error.traceID' | translate}}:
                    </strong>{{error.errorTraceId}}</span>
            </p>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn modal-btn" (click)="close()">OK</button>
    </div>
</ng-template>